<template>
  <div class="noAuth-container">
    <NoData :tips="tips" />
  </div>
</template>
<script>
import NoData from '@/components/NoData';

export default {
  name: 'Abnormal',
  components: {
    NoData,
  },
  data() {
    const tip = this.$isWXApplet ? '抱歉，登录已过期请重新登录' : '抱歉，当前账号暂无查看充电宝后台的权限';
    return {
      tips: this.$route.query.tips || tip,
    };
  },
};
</script>
